'use client';
import { ApiError } from '@lib/api-error';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { School } from 'types/collections';

import { SchoolService } from '@services/SchoolService';

export const useSchoolProfile = () => {
  const queryClient = useQueryClient();

  const { data, isPending, isError, error } = useQuery<School | null, ApiError>({
    queryKey: ['school-profile'],
    queryFn: () => new SchoolService().getSchoolProfile(),
  });

  const updateProfileMutation = useMutation({
    mutationFn: (updates: Partial<School>) =>
      new SchoolService().updateProfile(updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['school-profile'] });
    },
  });

  const deleteAccountMutation = useMutation({
    mutationFn: () => new SchoolService().requestAccountDeletion(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['school-profile'] });
    },
  });

  return {
    schoolProfile: data,
    isPending,
    isError,
    error,
    requestAccountDeletion: deleteAccountMutation.mutateAsync,
    deleteAccountError: deleteAccountMutation.error,
    updateProfile: updateProfileMutation.mutateAsync,
    isUpdating: updateProfileMutation.isPending,
    updateError: updateProfileMutation.error,
  };
};
